import { Link } from "react-router-dom";
import { Sparkles, Cloud, ArrowRight } from "lucide-react";
import { Seo } from "@/components/Seo";
import { ToolIcon } from "@/components/iconMap";
import { AI_TOOL_LIST } from "@/data/aiTools";

export default function AiTools() {
  return (
    <>
      <Seo title="AI Listing Tools for E-commerce Sellers | Ecroply AI"
        description="Free AI tools to write product titles, descriptions, bullet points and SEO keywords for Meesho, Flipkart, Amazon and Shopsy listings."
        path="/ai-tools" />

      <section className="relative overflow-hidden bg-slate-900">
        <div className="absolute inset-0 grid-dots opacity-10" />
        <div className="absolute top-0 right-0 w-[30rem] h-[30rem] bg-indigo-600/20 rounded-full blur-3xl" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20 text-center">
          <span className="inline-flex items-center gap-2 bg-indigo-500/20 text-indigo-200 border border-indigo-400/30 rounded-full px-4 py-1.5 text-sm font-medium mb-6">
            <Sparkles className="w-4 h-4" /> Powered by AI
          </span>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white tracking-tight">AI Listing Tools</h1>
          <p className="mt-4 text-lg text-slate-300 max-w-2xl mx-auto leading-relaxed">
            Turn a short product description into ready-to-use titles, descriptions, bullet points and SEO keywords for any marketplace.
          </p>
          <p className="mt-4 inline-flex items-center gap-2 text-sm text-slate-400">
            <Cloud className="w-4 h-4" /> The text you enter is sent to an AI service to generate your result.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {AI_TOOL_LIST.map((t) => (
            <Link key={t.path} to={t.path} data-testid={`ai-tool-card-${t.slug}`}
              className="group relative bg-white border border-slate-200 hover:border-indigo-400 rounded-2xl p-6 transition-all duration-300 hover:shadow-xl hover:shadow-indigo-500/5 hover:-translate-y-1 flex flex-col">
              <div className="w-12 h-12 rounded-xl bg-indigo-50 text-indigo-600 group-hover:bg-indigo-600 group-hover:text-white transition-colors flex items-center justify-center mb-4">
                <ToolIcon name={t.icon} className="w-6 h-6" />
              </div>
              <h3 className="font-heading font-bold text-lg text-slate-900">{t.name}</h3>
              <p className="mt-2 text-sm text-slate-600 flex-1">{t.promise}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-indigo-600">
                Open tool <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </span>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}
